// "use client"
import React from "react";
import { CardSkeleton } from "./card-skeleton";

export default function OverviewCareer({careerDesc, loading}: any) {
  return (
    <>
    {loading && <CardSkeleton />}
    <div className="p-2 bg-white w-[100%]">
      <h2 className="text-xl font-bold mb-4">About the role</h2>
      <h3 className="text-sm font-semibold mb-2">Overview</h3>
      <p className="mb-2 text-sm">
        Company name: Botbyte AI | HQ Location: Pune, Maharashtra |{" "}
        <a href="/careers" className="text-blue-600 underline text-sm">
          Careers
        </a>{" "}
        |{" "}
        <a href="/" className="text-blue-600 underline text-sm">
          Botbyte AI
        </a>
      </p>
      <p className="mb-2 text-sm">Role: {careerDesc?.designation}</p>
      <h3 className="text-sm font-semibold mb-2">About the company</h3>
      <p className="mb-2 text-sm">Job Description</p>
      <p className="mb-4 text-sm">
       {careerDesc?.description}
      </p>
    </div>
    </>
  );
}
